import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('adminToken') || null);
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (token) {
      localStorage.setItem('adminToken', token);
      setIsAuthenticated(true);
      
      // Decode JWT payload to get the role
      try {
        const payloadBase64 = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payloadBase64));
        setRole(decodedPayload.role || 'editor'); // fallback to editor if none found
      } catch (e) {
        console.error('Error decoding token', e);
        setRole(null);
      }
    } else {
      localStorage.removeItem('adminToken');
      setIsAuthenticated(false);
      setRole(null);
    }
  }, [token]);

  const login = (newToken) => {
    setToken(newToken);
  };

  const logout = () => {
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
